import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { FlatButton } from "src/framework/components/buttons/FlatButton";

import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Error } from "@mui/icons-material";
import theme from "src/theme/light";
import { useMemo, useState } from "react";
import defaultListStore from "src/framework/store/DefaultListStore";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { resolveUploadUrl } from "src/store/global.store";

interface ModalFaturamentoProps {
  open: boolean;
  onClose: () => void;
  imgUrl: string;
  title: string;
  size?: string;
}

const useStyles = makeStyles({
  buttonLink: {
    background: 'none',
    border: 'none',
    padding: 0,
    color: '#069',
    textDecoration: 'underline',
    cursor: 'pointer',
  }
})

const ModalFaturamento = ({ open, onClose, title, imgUrl, size = "300px"}: ModalFaturamentoProps) => {
  const classes = useStyles()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [showVideo, setShowVideo] = useState(false)

  const videoUrl = useMemo(()=>{
    const uploadInfo = LocalStorage.get("solar.uploadInfo", true) || '';
    const uploadUrl = defaultListStore?.uploadUrl || resolveUploadUrl(uploadInfo);
    const isProd = String(process.env.REACT_APP_IS_PROD).toUpperCase() === "TRUE";
    const pathBucket = isProd ? 'producao' : 'homologacao';
    return `https://${uploadUrl}/${pathBucket}/projetos/assets/video-explicativo-projetos.mp4`;
  },[])
  
  if (!open) return null;

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
      >
        <DialogTitle>
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Box>
              Atenção
              <Typography variant='body2' color='textSecondary'>
                {title}
              </Typography>
            </Box>
            <Box>
              <Error htmlColor={theme.palette.primary.dark} />
            </Box>
          </Box>
        </DialogTitle>

        <Box paddingBottom={2}>
          <Divider />
        </Box>

        <DialogContent
          style={{
            minWidth: isMobile ? '100%' : size,
          }}
        >
          {videoUrl && (
            <DialogContentText>
              <img width={isMobile ? '100%' : '550px'} height='auto' src={imgUrl} alt='tipo-faturamento' />
              <Typography variant='subtitle2' color="textSecondary" >Ainda está com dúvidas? Assista nosso vídeo explicativo. Basta clicar <button className={classes.buttonLink} onClick={() => setShowVideo(true)}>aqui</button>.</Typography>
            </DialogContentText>
          )}
        
          {showVideo && (
            <video width='100%' controls preload="auto">
              <source src={videoUrl}></source>
              Não foi possível carregar o vídeo.
            </video>
          )}
    
        </DialogContent>
        <DialogActions>
          <FlatButton
            onClick={onClose}
            color="primary"
            variant="contained"
            text={"Fechar"}
          />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export { ModalFaturamento };
